// Local content data - no API fetch needed
// This ensures instant rendering in production

export const profileData = {
  name: "DJ NEFF",
  tagline: "NY-Based DJ, Producer & Artist",
  bio_short: "Extremely versatile, DJ NEFF caters to every crowd by blending genres from Hip-Hop to Salsa. Raised in a Dominican household rich in art and music, he grew up immersed in diverse sounds that shaped his originality, technical skill, and ability to move any room.",
  bio_full: `Nefthaly Herrera, also known as DJ NEFF, was born and raised in the Bronx, NY.

Music has always been in his blood. Surrounded by a deeply artistic and musically talented family, he naturally gravitated toward sound and rhythm. One day, he decided to try DJing — and within just a few months of focused practice, it became a dream turned reality.

Known for his uplifting energy and entrepreneurial mindset, DJ NEFF is a natural fit for the entertainment industry. He is energetic, outgoing, hardworking, reliable, and most importantly, the life of the party.

Whether it's a club, private event, concert, or even your backyard, DJ NEFF is committed to exceeding expectations and delivering an unforgettable experience.`,
  hero_image: "https://customer-assets.emergentagent.com/job_professional-epk/artifacts/kvqdkftc_4C382F89-7BCF-4795-B90B-FBD54F36DEC1_2-removebg-preview.png",
  bio_image: "https://customer-assets.emergentagent.com/job_professional-epk/artifacts/i9qv19im_neff-4630%203.JPG",
  logo_url: "https://customer-assets.emergentagent.com/job_professional-epk/artifacts/k20ff6ft_IMG_4353_2-removebg-preview.png"
};

export const socialData = {
  title: "SOCIAL MEDIA",
  platforms: [
    { name: "Instagram", handle: "@_ok.neff", url: "https://instagram.com/_ok.neff" },
    { name: "TikTok", handle: "@ok.neff", url: "https://www.tiktok.com/@ok.neff" },
    { name: "YouTube", handle: "@okneff", url: "https://www.youtube.com/@okneff" },
    { name: "Twitch", handle: "okneff", url: "https://twitch.tv/okneff" },
    { name: "SoundCloud", handle: "okneff", url: "https://soundcloud.com/okneff" },
    { name: "MixCloud", handle: "okneff", url: "https://www.mixcloud.com/okneff/" }
  ]
};

export const mediaData = {
  videos: [
    {
      id: 1,
      thumbnail: "https://images.unsplash.com/photo-1571266028243-d220c6e87bf0?w=800&h=600&fit=crop",
      title: "Performance at Arc de Triomphe",
      url: "#"
    },
    {
      id: 2,
      thumbnail: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&h=600&fit=crop",
      title: "Studio Session",
      url: "#"
    },
    {
      id: 3,
      thumbnail: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=800&h=600&fit=crop",
      title: "Live at Sunset",
      url: "#"
    }
  ],
  photos: [
    {
      id: 1,
      url: "https://images.unsplash.com/photo-1571266028243-d220c6e87bf0?w=600&h=800&fit=crop",
      alt: "DJ NEFF Performance 1"
    },
    {
      id: 2,
      url: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=800&fit=crop",
      alt: "DJ NEFF Performance 2"
    },
    {
      id: 3,
      url: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=800&fit=crop",
      alt: "DJ NEFF Performance 3"
    }
  ]
};

export const musicStoreData = {
  description: "Exclusive mixes, remixes, and blends - Available for digital download",
  products: [
    {
      id: 1,
      title: "Afro House Summer Mix 2024",
      category: "mix",
      price: 0,
      duration: "45:32",
      coverArt: "https://images.unsplash.com/photo-1571266028243-d220c6e87bf0?w=600&h=600&fit=crop"
    },
    {
      id: 2,
      title: "Deep House Session Vol. 3",
      category: "mix",
      price: 9.99,
      duration: "62:18",
      coverArt: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=600&fit=crop"
    },
    {
      id: 3,
      title: "La Vie La Nuit - Exclusive Remix",
      category: "remix",
      price: 4.99,
      duration: "5:47",
      coverArt: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=600&fit=crop"
    },
    {
      id: 4,
      title: "Hip-Hop Meets House Blend",
      category: "blend",
      price: 0,
      duration: "38:15",
      coverArt: "https://images.unsplash.com/photo-1571266028243-d220c6e87bf0?w=600&h=600&fit=crop"
    },
    {
      id: 5,
      title: "Paris After Dark Remix Pack",
      category: "remix",
      price: 14.99,
      duration: "Multiple Tracks",
      coverArt: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=600&fit=crop"
    },
    {
      id: 6,
      title: "Afro-Latin Blend Experience",
      category: "blend",
      price: 7.99,
      duration: "52:40",
      coverArt: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=600&fit=crop"
    }
  ]
};

export const eventsData = {
  description: "Catch DJ NEFF live at these upcoming shows and promotional events",
  promotional: true,
  upcoming: [
    {
      id: 1,
      title: "Rex Club Paris - House Night",
      venue: "Rex Club",
      location: "Paris, France",
      date: "2024-03-15",
      day: "15",
      month: "MAR",
      year: "2024",
      time: "23:00 - 05:00",
      event_type: "Club Night",
      ticket_status: "available",
      ticket_url: "#",
      is_active: true
    },
    {
      id: 2,
      title: "Afro House Festival",
      venue: "Parc de la Villette",
      location: "Paris, France",
      date: "2024-04-22",
      day: "22",
      month: "APR",
      year: "2024",
      time: "18:00 - 02:00",
      event_type: "Festival",
      ticket_status: "available",
      ticket_url: "#",
      is_active: true
    },
    {
      id: 3,
      title: "La Vie La Nuit Podcast Live",
      venue: "Wanderlust",
      location: "Paris, France",
      date: "2024-05-10",
      day: "10",
      month: "MAY",
      year: "2024",
      time: "21:00 - 03:00",
      event_type: "Podcast Recording",
      ticket_status: "sold out",
      ticket_url: "#",
      is_active: true
    },
    {
      id: 4,
      title: "Summer Vibes at CHICHI",
      venue: "CHICHI",
      location: "Paris, France",
      date: "2024-06-28",
      day: "28",
      month: "JUN",
      year: "2024",
      time: "22:00 - 04:00",
      event_type: "Club Night",
      ticket_status: "available",
      ticket_url: "#",
      is_active: true
    },
    {
      id: 5,
      title: "International DJ Tour - Barcelona",
      venue: "Razzmatazz",
      location: "Barcelona, Spain",
      date: "2024-07-14",
      day: "14",
      month: "JUL",
      year: "2024",
      time: "23:30 - 06:00",
      event_type: "Tour",
      ticket_status: "available",
      ticket_url: "#",
      is_active: true
    }
  ]
};

export const contactData = {
  email: "nefthalyherrerallc@gmail.com",
  phone: "+33 6 12 34 56 78",
  website: "djneff.com"
};

export const pressKitData = {
  title: "DOWNLOAD PRESS KIT",
  description: "Access high-resolution photos, biography, and technical rider",
  fileUrl: "#"
};

export const merchData = {
  enabled: false
};